import { designSystemColors } from '@klv/shared/styles/colors';

const twoColumnL30R70 = {
  divider: designSystemColors.poppy,
};


export default twoColumnL30R70;
